import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import FeatherIcon from "feather-icons-react";
import { CustomModal } from "../../../components/CustomModel/CustomModal";
import { requestTournamentRefresh } from "../../../utils/tournamentRefreshBus";
import TournamentPlayersSettings from "../players/TournamentPlayersSettings";
import TournamentDrawStagesSettings from "../draws/TournamentDrawStagesSettings";
import TournamentScheduleSettings from "../schedule/TournamentScheduleSettings";
import TournamentRatingSettings from "../rating/TournamentRatingSettings";

const TABS = [
    { key: "players", label: "Participants" },
    { key: "draw-stages", label: "Draw" },
    { key: "schedule", label: "Schedule" },
    { key: "rating", label: "Rating" },
];

const TournamentSettingsModal = ({ tournamentId, tournament, setTournament, isOpen, initialTab, onClose }) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState(initialTab || "players");

    useEffect(() => {
        if (isOpen) {
            setActiveTab(initialTab || "players");
        }
    }, [isOpen, initialTab]);

    const handleSaved = () => {
        toast.success(t("Settings saved"));
        requestTournamentRefresh(tournamentId);
    };

    const handleReset = () => {
        toast.success(t("Settings reset"));
        requestTournamentRefresh(tournamentId);
    };

    return (
        <CustomModal isOpen={isOpen} onClose={onClose}>
            <form className="modal-form" onSubmit={(e) => e.preventDefault()}>
            <div className="modal-sticky-header">
                <h2>
                    <FeatherIcon icon="settings" /> {t("Tournament settings")}
                </h2>
                <nav className="tabs-container" style={{ marginTop: "10px" }}>
                    <ul className="tabs">
                        {TABS.map(tab => (
                            <li key={tab.key} className={activeTab === tab.key ? "active" : ""}>
                                <a
                                    href="#"
                                    className={`action-button ${activeTab === tab.key ? "btn-green" : ""}`}
                                    onClick={(e) => { e.preventDefault(); setActiveTab(tab.key); }}
                                >
                                    {t(tab.label)}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>

            {activeTab === "players" && (
                <TournamentPlayersSettings
                    tournamentId={tournamentId}
                    tournamentBlocks={tournament?.blocks}
                    setTournament={setTournament}
                    onSaved={handleSaved}
                    onReset={handleReset}
                    onClose={onClose}
                />
            )}
            {activeTab === "draw-stages" && (
                <TournamentDrawStagesSettings
                    tournamentId={tournamentId}
                    tournamentBlocks={tournament?.blocks}
                    setTournament={setTournament}
                    onSaved={handleSaved}
                    onReset={handleReset}
                    onClose={onClose}
                />
            )}
            {activeTab === "schedule" && (
                <TournamentScheduleSettings
                    tournamentId={tournamentId}
                    tournamentBlocks={tournament?.blocks}
                    setTournament={setTournament}
                    onSaved={handleSaved}
                    onReset={handleReset}
                    onClose={onClose}
                />
            )}
            {activeTab === "rating" && (
                <TournamentRatingSettings
                    tournamentId={tournamentId}
                    tournamentBlocks={tournament?.blocks}
                    setTournament={setTournament}
                    onSaved={handleSaved}
                    onReset={handleReset}
                    onClose={onClose}
                />
            )}
            </form>
        </CustomModal>
    );
};

export default TournamentSettingsModal;
